import State from '../core/State';

export const increment = () => (state: State): State => ({
  ...state,
  fullScreenSpinner: {
    ...state.fullScreenSpinner,
    necessity: state.fullScreenSpinner.necessity + 1,
  },
});

export const setLoadingMessage = (loadingMessage: string) => (state: State): State => ({
  ...state,
  fullScreenSpinner: {
    ...state.fullScreenSpinner,
    loadingMessage,
  },
});

export const decrement = () => (state: State): State => {
  const decremented = state.fullScreenSpinner.necessity - 1;
  return {
    ...state,
    fullScreenSpinner: {
      ...state.fullScreenSpinner,
      necessity: decremented,
      loadingMessage: decremented === 0 ? '' : state.fullScreenSpinner.loadingMessage,
    },
  };
};
